import { render, staticRenderFns } from "./QuestionBankTagsForm.vue?vue&type=template&id=05b34ae8&scoped=true&"
import script from "./QuestionBankTagsForm.vue?vue&type=script&lang=js&"
export * from "./QuestionBankTagsForm.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBankTagsForm.vue?vue&type=style&index=0&id=05b34ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b34ae8",
  null
  
)

export default component.exports